(function () {
  var productCache = {};
  var inFlight = {};

  function extractHandle(card) {
    var link = card.querySelector('a.snize-view-link, a[href*="/products/"]');
    if (!link) return null;
    var m = link.getAttribute('href').match(/\/products\/([^?#/]+)/);
    return m ? m[1] : null;
  }

  function updateCartBubble() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-icon-bubble'] || '';
        var parsed = new DOMParser().parseFromString(html, 'text/html');

        // Update header bubble (#cart-icon-bubble2 used by this theme)
        var bubble2 = document.querySelector('#cart-icon-bubble2');
        var section = parsed.querySelector('#shopify-section-cart-icon-bubble');
        if (bubble2 && section) bubble2.innerHTML = section.innerHTML;

        // Ensure cart count badge is visible
        var countBubble = document.querySelector('.element-headerSteps .cart-count-bubble');
        if (countBubble) countBubble.classList.remove('hide');

        // Fire Dawn's pub-sub event so cart drawer / mini-cart can update
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cartData) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'snize-atc', cartData: cartData });
            });
        }
      });
  }

  function doAddToCart(variantId, btn) {
    // Use XHR instead of fetch to bypass Kaching's window.fetch wrapper,
    // which transforms cart-add requests and causes 422 errors.
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        updateCartBubble().catch(function () {}).then(function () {
          btn.disabled = false;
          btn.classList.remove('snize-kika-atc--loading');
        });
      } else {
        console.error('[snize-variants] Cart add failed:', xhr.status, xhr.responseText);
        btn.disabled = false;
        btn.classList.remove('snize-kika-atc--loading');
      }
    };
    xhr.onerror = function () {
      console.error('[snize-variants] Cart add network error');
      btn.disabled = false;
      btn.classList.remove('snize-kika-atc--loading');
    };
    xhr.send(JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }));
  }

  function addToCart(variantId, btn) {
    btn.disabled = true;

    // If cart-normalizer is not on the page, just add directly
    if (!document.getElementById('cart-normalizer-pickup-confirm')) {
      btn.classList.add('snize-kika-atc--loading');
      doAddToCart(variantId, btn);
      return;
    }

    // Route through the normalizer via a hidden form so it can run the
    // pickup-only check and show the confirmation popup if needed.
    // The normalizer intercepts forms with data-type="add-to-cart-form".
    var form = document.createElement('form');
    form.action = '/cart/add';
    form.method = 'post';
    form.setAttribute('data-type', 'add-to-cart-form');
    form.style.cssText = 'position:fixed;top:-9999px;width:0;height:0;overflow:hidden;opacity:0;pointer-events:none;';

    var addInput = function (name, val) {
      var inp = document.createElement('input');
      inp.type = 'hidden'; inp.name = name; inp.value = val;
      form.appendChild(inp);
    };
    addInput('id', String(variantId));
    addInput('quantity', '1');

    // Store btn so the cancel handler in cart-normalizer can re-enable it
    form._snizeAtcBtn = btn;

    // On the confirmed re-submit (second fire, after pickup check passes),
    // intercept to do AJAX instead of a full-page POST.
    form.addEventListener('submit', function onResubmit(e) {
      e.preventDefault();
      form.removeEventListener('submit', onResubmit);
      if (form.parentNode) form.parentNode.removeChild(form);
      btn.classList.add('snize-kika-atc--loading');
      doAddToCart(variantId, btn);
    });

    document.body.appendChild(form);
    form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }

  // Ensure kikaSelectedVariant is always set from product data.
  // Covers single-variant products where the Searchanise link has no ?variant=.
  function setVariantFromProduct(card, product) {
    if (card.dataset.kikaSelectedVariant || !product || !product.variants || !product.variants.length) return;
    var v = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    if (v) {
      card.dataset.kikaSelectedVariant = String(v.id);
      var link = card.querySelector('a.snize-view-link');
      if (link && link.getAttribute('href').indexOf('variant=') === -1) {
        link.href = '/products/' + product.handle + '?variant=' + v.id;
      }
    }
  }

  function injectVariants(card, product) {
    if (card.querySelector('.snize-kika-variants')) return;
    if (!product) return;
    // IO-5355: the collection card (snippets/product-card.liquid) renders a pill for
    // every available variant, single-variant products included -- that is where a
    // lone "75 g" pill comes from. Match that rather than requiring two variants.
    if (!product.variants.length) return;

    // /products/<handle>.js returns options as {name, position, values} objects, so the
    // string compare this guard used to do never matched and every placeholder product
    // was only ever saved by the variants > 1 check above. Read .name, and drop the
    // placeholder labels per variant too, so a product that reports real options but
    // still carries "Default Title" values cannot render a meaningless pill.
    var optionNames = (product.options || []).map(function (o) {
      return o && typeof o === 'object' ? o.name : o;
    });
    if (optionNames.length === 1 && optionNames[0] === 'Title') return;

    var overhidden = card.querySelector('.snize-overhidden');
    var titleEl = overhidden && overhidden.querySelector('.snize-title');
    if (!titleEl) return;

    var link = card.querySelector('a.snize-view-link');
    var currentVariantId = null;
    if (link) {
      var m = link.getAttribute('href').match(/[?&]variant=(\d+)/);
      if (m) currentVariantId = parseInt(m[1], 10);
    }

    var availableVariants = product.variants.filter(function (v) { return v.available; });
    if (!availableVariants.length) return;

    var activeVariant = availableVariants.find(function (v) { return v.id === currentVariantId; })
      || availableVariants[0];

    var container = document.createElement('div');
    container.className = 'snize-kika-variants';

    var seen = {};
    availableVariants.forEach(function (variant) {
      var label = variant.option1 || variant.title;
      if (!label || label === 'Default Title') return;
      if (seen[label]) return;
      seen[label] = true;

      var pill = document.createElement('span');
      pill.className = 'snize-kika-variant-pill' + (variant.id === activeVariant.id ? ' active' : '');
      pill.textContent = label;
      pill.dataset.variantId = String(variant.id);
      pill.dataset.variantUrl = '/products/' + product.handle + '?variant=' + variant.id;

      pill.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        container.querySelectorAll('.snize-kika-variant-pill').forEach(function (p) {
          p.classList.remove('active');
        });
        pill.classList.add('active');

        if (link) link.href = pill.dataset.variantUrl;
        card.dataset.kikaSelectedVariant = pill.dataset.variantId;

        if (window.kikaSnize && window.kikaSnize.refreshCard) {
          window.kikaSnize.refreshCard(card, pill.dataset.variantId);
        }
      });

      container.appendChild(pill);
    });

    if (!container.children.length) return;

    titleEl.insertAdjacentElement('afterend', container);

    card.dataset.kikaSelectedVariant = String(activeVariant.id);
    if (link) link.href = '/products/' + product.handle + '?variant=' + activeVariant.id;
  }

  function replaceAtcButton(card) {
    if (card.dataset.kikaAtcDone) return;
    card.dataset.kikaAtcDone = '1';

    var snizeBtn = card.querySelector('.snize-add-to-cart-button');
    if (!snizeBtn) return;

    var label = snizeBtn.textContent.trim() || 'Į krepšelį';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'snize-kika-atc-button';
    btn.textContent = label;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var variantId = card.dataset.kikaSelectedVariant;

      if (!variantId) {
        var link = card.querySelector('a.snize-view-link');
        if (link) {
          var m = link.getAttribute('href').match(/[?&]variant=(\d+)/);
          if (m) variantId = m[1];
        }
      }

      if (variantId) {
        addToCart(variantId, btn);
      }
    });

    snizeBtn.parentNode.replaceChild(btn, snizeBtn);
  }

  function processCard(card) {
    if (card.dataset.kikaVariantsProcessed) return;
    card.dataset.kikaVariantsProcessed = '1';

    replaceAtcButton(card);

    var handle = extractHandle(card);
    if (!handle) return;

    var link = card.querySelector('a.snize-view-link');
    if (link) {
      var m = link.getAttribute('href').match(/[?&]variant=(\d+)/);
      if (m) card.dataset.kikaSelectedVariant = m[1];
    }

    if (productCache[handle] !== undefined) {
      injectVariants(card, productCache[handle]);
      setVariantFromProduct(card, productCache[handle]);
      return;
    }

    var waiters = inFlight[handle];
    if (waiters) { waiters.push(card); return; }
    inFlight[handle] = [card];

    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        productCache[handle] = data;
        (inFlight[handle] || []).forEach(function (c) {
          injectVariants(c, data);
          setVariantFromProduct(c, data);
        });
        delete inFlight[handle];
      })
      .catch(function () {
        productCache[handle] = null;
        delete inFlight[handle];
      });
  }

  function scanCards(root) {
    (root || document).querySelectorAll('li.snize-product:not([data-kika-variants-processed])').forEach(processCard);
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('li.snize-product')) {
          processCard(node);
        } else {
          scanCards(node);
        }
      });
    });
  });

  function init() {
    scanCards(document);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
